import ActiveAlarmsCard from './ActiveAlarmsCard';
export default ActiveAlarmsCard;
